module.exports = __webpack_public_path__ + "img/rimik.e0f1575a.svg";